exports.components = {
  "component---src-pages-en-au-contact-us-submitted-tsx": () => import("./../../../src/pages/en-AU/contact-us-submitted.tsx" /* webpackChunkName: "component---src-pages-en-au-contact-us-submitted-tsx" */),
  "component---src-pages-en-au-index-tsx": () => import("./../../../src/pages/en-AU/index.tsx" /* webpackChunkName: "component---src-pages-en-au-index-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

